// import Vue from 'vue'
import axios from 'axios'
// import { Message } from '@jd/element-ui'
import { isNull } from '@/utils'
import Cookies from 'js-cookie'
import Raven from 'raven-js'
// import {LINK} from ''
import getTranslation from '@/i18n/getTranslation'
const service = axios.create({
  timeout: 20000,
  withCredentials: true
})

service.interceptors.request.use((config) => {
  if (config.isCsrf && Cookies.get('csrfToken')) {
    Object.assign(config.headers, {
      'x-csrf-token': Cookies.get('csrfToken')
    })
  }
  return config
})
service.interceptors.response.use(
  (response) => {
    let {
      data: { code, success, message, data }
    } = response
    // 如果不是code 返回值
    if (isNull(code) && isNull(success)) {
      return response.data
    }
    if (code !== 0 || success === false) {
      // 是否自动提示消息
      // if (config.isOutMsg) {
      //   Message({
      //     type: 'error',
      //     message: message || msg || '出错啦，请确认网络是否正常，稍后再试'
      //   })
      // }
    return Promise.reject({ code, data, message:getTranslation(message) }); // eslint-disable-line
    } else {
      return response.data
    }
  },
  (error) => {
    // ARR_LOADING = []
    // if (LOADING_INSTANCE) {
    //   LOADING_INSTANCE.close()
    //   LOADING_INSTANCE = null
    // }
    // IS_LOADING = false
    const {
      response: { data }
    } = error
    if (error.response && error.response.status === 401) {
      if (error.response.data && error.response.data.loginUrl) {
        window.location.href = `${decodeURIComponent(
          error.response.data.loginUrl
        )}?returnUrl=${encodeURIComponent(window.location.href)}`
      }
      return Promise.reject(error)
    }

    if (status === 402) {
      window.location.href = derivativeConfig.active + encodeURIComponent(window.location.href)
      return
    }
    if (status === 403) {
      Notification.error({
        title: getTranslation('您没有权限执行此操作，请联系管理员为您添加权限。'),
        message: getTranslation(data.message),
        duration: 10000
      })
    } else {
      if (process.env.NODE_ENV === 'production') {
        Raven.captureException(error)
      }
    }
    return Promise.reject({
      ...data.error,
      message: getTranslation(
        (data.error && data.error.message) || '出错啦，请确认网络是否正常，稍后再试'
      )
    })
  }
)
export default service
